import { useContext } from 'react'

import PortalRootsContext, { initialState } from '~context/portalRootsContext'

const usePortalRoots = (): Record<keyof typeof initialState, HTMLElement | null> => {
  return useContext(PortalRootsContext)
}

export default usePortalRoots
